<template>
  <div class="widget">
    <div class="widget-label">
      <div class="label">
        <p>Actions Taken</p>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-table
          responsive
          :items="sortedActions"
          :fields="fields"
          class="action-items"
        >
          <template #cell()="data">
            <span>{{ data.value ? data.value : '--' }}</span>
          </template>
          <template v-slot:cell(type)="data">
            <div class="lvl">
              <span>{{ data.item.type }}</span>
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <b-link @click="viewProjectMetric(data.item.projectMetricId)">
              {{ data.item.name }}
            </b-link>        
          </template>
          <template v-slot:cell(comments)="data">
            {{ getFirstComment(data.item) }}
          </template>
          <template v-slot:cell(dateDue)="data">
            {{ data.item.dateDue ? $helpers.formatDateWithRelativeWords( data.item.dateDue ) : '--' }}
          </template>
          <template v-slot:cell(champion)="data">
            <div :class="{'text-danger':  data.item.overDue }">
              <span v-if="data.item.assignedToUsers.length == 0">--</span>
              <span v-else>{{
                data.item.assignedToUsers.map((u) => u.name).join(", ")
              }}</span>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <ViewProjectMetricModal
      ref="view-project-metric-modal"
      :projectMetric="viewingProjectMetric"
      @refresh="refreshProjectMetric"
    ></ViewProjectMetricModal>
  </div>
</template>

<script>
// import axios from "axios";
import ViewProjectMetricModal from "@/components/modals/ViewProjectMetricModal.vue";

export default {
  components: {
    ViewProjectMetricModal,
  },
  props: {
    actions: { type: Array, required: true }
  },
  data() {
    return {
      fields: [
        {
          key: "type",
          label: "Type",
          tdClass: (value) => this.getTypeClasses(value),
          thClass: "skinny-col",
          sortable: true
        },
        { key: "name", label: "Name", tdClass: "meta-header", sortable: true },
        { key: "comments", label: "Latest Comment", tdClass: "data", sortable: true },
        { key: "dateDue", label: "Due Date", tdClass: "data", sortable: true },
        { key: "champion", label: "Champions", tdClass: "data", sortable: true },
      ],
      viewingProjectMetricId: '',
    }
  },
  computed: {
    viewingProjectMetric() {
      console.log('viewingProjectMetric');
      console.log(this.actions.find(
        (action) => action.projectMetricId === this.viewingProjectMetricId
      ));
      return this.actions.find(
        (action) => action.projectMetricId === this.viewingProjectMetricId
      );
    },
    sortedActions() {
      return this.actions.sort((action1, action2) => 
        this.$helpers.compareDates(action1.dateCreated, action2.dateCreated));
    }
  },
  watch: {

  },
  mounted() {
    // this.loadData();
    console.log('MeetingActionsTaken');
    console.log(this.actions);
  },
  methods: {
    getFirstComment(item) {
      return item.comments.length > 0 ?
        item.comments[0].content : item.description ?
        item.description :
        '--';
    },
    getTypeClasses(type) {
      return type.toLowerCase().replace(/ /g, "-");
    },
    viewProjectMetric(id) {
      console.log('viewProjectMetric');
      console.log(id);
      this.viewingProjectMetricId = id;

      this.$nextTick(() => {
        this.$refs["view-project-metric-modal"].show();
      });
    },
    refreshProjectMetric(id) {
      this.$emit("refresh", id);
      this.$nextTick(() => {
        // this.$refs["edit-project-metric-modal"].reset();
        this.$refs["view-project-metric-modal"].reset();
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
